import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Header } from "@/components/Header";
import { HeroSection } from "@/components/HeroSection";
import { ChallengeSection } from "@/components/ChallengeSection";
import { ArchitectureSection } from "@/components/ArchitectureSection";
import { AgentsSection } from "@/components/AgentsSection";
import { CapabilitiesSection } from "@/components/CapabilitiesSection";
import { DifferenceSection } from "@/components/DifferenceSection";
import { IntegrationsSection } from "@/components/IntegrationsSection";
import { SafeSection } from "@/components/SafeSection";
import { TestimonialsSection } from "@/components/TestimonialsSection";
import { SurveyInsightsSection } from "@/components/SurveyInsightsSection";
import { MetricsSection } from "@/components/MetricsSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import { Send } from "lucide-react";

function App() {
  const [scrolled, setScrolled] = useState(false);
  const [showFloat, setShowFloat] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
      setShowFloat(window.scrollY > 600);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToDemo = () => document.getElementById("demo")?.scrollIntoView({ behavior: "smooth" });

  return (
    <div className="min-h-screen bg-background text-foreground font-body">
      <Header scrolled={scrolled} />
      <main>
        <HeroSection />
        <ChallengeSection />
        <ArchitectureSection />
        <AgentsSection />
        <CapabilitiesSection />
        <DifferenceSection />
        <IntegrationsSection />
        <SafeSection />
        <TestimonialsSection />
        <SurveyInsightsSection />
        <MetricsSection />
        <ContactSection />
      </main>
      <Footer />
      <Toaster position="bottom-right" />

      {/* Floating Book Demo CTA */}
      <AnimatePresence>
        {showFloat && (
          <motion.button
            initial={{ opacity: 0, y: 20, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.9 }}
            onClick={scrollToDemo}
            className="fixed bottom-6 right-6 z-50 btn-teal px-5 py-3 flex items-center gap-2 shadow-xl rounded-full text-sm"
            style={{ boxShadow: '0 4px 24px rgba(0,168,179,0.4)' }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Send className="w-4 h-4" />
            Book Demo
          </motion.button>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
